<template>
    <div>
        <input-group icon="fa fa-newspaper-o">
            <v-select class='form-control'
                      v-model="selectedOptions"

                      :options="availableOptions"
                      :clearable="true"

                      label='label'

                      :close-on-select="false"
                      multiple
            />
        </input-group>
    </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'; 

import api from "@modules/JourneyBuilder/api";
import {bootstrapDangerGrowl} from "@core/Util/growler";

import VSelect from 'vue-select';
import InputGroup from "@core/Components/Inputs/InputGroup";

export default {
    name: "ProductsSelector",
    
    components: {
        VSelect,
        InputGroup
    },

    data() {
        return {
            options: []
        }
    },

    computed: {
        ...mapState('journeyBuilder/reporting', [ 'productNames' ]),

        selectedOptions: {
            get(){
                return this.options.filter(o => this.productNames.includes(o.name));
            },
            set(value){
                this.setProductNames(value.map(o => o.name));
            }
        },
        availableOptions(){
            //Only non-selected options should be selectable to avoid confusion
            return this.options.filter(o => !this.productNames.includes(o.name));
        }
    },
    
    async created() {
        try {
            this.options = await api.getProducts();
        } catch (e) {
            bootstrapDangerGrowl(e);
        }
    },
    
    methods: {
        ...mapMutations('journeyBuilder/reporting', [ 'setProductNames' ])
    }
}
</script>
